/* ════════════════════════════════════════════════════════════════
   Tessera Diamonds — Education page TOC smooth-scroll
   Uses the global Lenis instance (window.tdLenis) with a native fallback.
   ════════════════════════════════════════════════════════════════ */
(function () {
  const pills = document.querySelectorAll('.toc__pill[href^="#"]');
  if (!pills.length) return;
  pills.forEach(pill => {
    pill.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(pill.getAttribute('href'));
      if (!target) return;
      if (window.tdLenis) window.tdLenis.scrollTo(target, { offset: -60, duration: 1.4 });
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
